import { gql } from "@apollo/client";

// Query to get all chats for the current user
export const GET_USER_CHATS = gql`
  query GetUserChats($userId: ID!) {
    chatsList(filter: { members: { some: { id: { equals: $userId } } } }) {
      items {
        id
        createdAt
        updatedAt
        members {
          items {
            id
            email
            firstName
            lastName
            avatar {
              downloadUrl
            }
          }
        }
        chatMessages(
          first: 1
          sort: { createdAt: DESC }
        ) {
          items {
            id
            message
            messageType
            createdAt
            createdBy {
              id
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`;

// Query to get messages for a specific chat
export const GET_CHAT_MESSAGES = gql`
  query GetChatMessages($chatId: ID!) {
    chatMessagesList(
      filter: { chatRoom: { some: { id: { equals: $chatId } } } }
      sort: { createdAt: ASC }
    ) {
      items {
        id
        message
        messageType
        createdAt
        createdBy {
          id
          firstName
          lastName
          avatar {
            downloadUrl
          }
        }
        users {
          items {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;

// Mutation to create a new chat
export const CREATE_CHAT = gql`
  mutation CreateChat($data: ChatCreateInput!) {
    chatCreate(data: $data) {
      id
      createdAt
      members {
        items {
          id
          email
          firstName
          lastName
          avatar {
            downloadUrl
          }
        }
      }
    }
  }
`;

// Mutation to send a message
export const SEND_MESSAGE = gql`
  mutation Send($chatId: ID!, $message: String!, $senderId: ID, $messageType: String) {
    sendChatMessage(chatId: $chatId, message: $message, senderId: $senderId, messageType: $messageType) {
      success
      chatMessageId
      notified
      failed
      tokens
    }
  }
`;

// Subscription for real-time messages (exact copy from mobile app)
export const MESSAGE_SUBSCRIPTION = gql`
  subscription ChatMessages($chatId: ID!) {
    ChatMessages(
      filter: {
        mutation_in: [create, update]
        node: {chatRoom: {some: {id: {equals: $chatId}}}}
      }
    ) {
      mutation
      node {
        id
        message
        updatedAt
        createdAt
        users {
          items {
            email
            firstName
            id
          }
        }
        chatRoom {
          items {
            id
          }
        }
      }
    }
  }
`;

// Query to get all users for creating new chats
export const GET_ALL_USERS = gql`
  query GetAllUsers {
    usersList {
      items {
        id
        email
        firstName
        lastName
        avatar {
          downloadUrl
        }
      }
    }
  }
`;

// Subscription for chat list updates (fixed structure)
export const CHAT_LIST_SUBSCRIPTION = gql`
  subscription SimpleChatSubscription {
    ChatMessages {
      mutation
      node {
        id
        message
        createdAt
        users {
          items {
            email
            firstName
            id
          }
        }
        chatRoom {
          items {
            id
          }
        }
      }
    }
  }
`;

// FCM Token Mutations
export const ADD_FCM_TOKEN = gql`
  mutation AddFCMToken($userId: ID!, $token: String!, $deviceInfo: String!, $platform: String!) {
    userTokenCreate(data: {
      token: $token
      users: { connect: { id: $userId } }
      deviceInfo: $deviceInfo
      platform: $platform
    }) {
      id
      token
      users {
        id
        email
        firstName
        lastName
      }
      deviceInfo
      platform
      createdAt
    }
  }
`;

export const UPDATE_FCM_TOKEN = gql`
  mutation UpdateFCMToken($tokenId: ID!, $token: String!) {
    userTokenUpdate(data: { 
      id: $tokenId, 
      token: $token
    }) {
      id
      token
      platform
      deviceInfo
      updatedAt
    }
  }
`;

export const DELETE_ALL_USER_TOKENS = gql`
  mutation DeleteAllUserTokens($userId: ID!) {
    userTokenDeleteMany(
      filter: { 
        users: { id: { equals: $userId } }
      }
    ) {
      count
    }
  }
`;

export const GET_USER_TOKENS = gql`
  query GetUserTokens($userId: ID!) {
    userTokensList(
      filter: { 
        users: { id: { equals: $userId } }
        platform: { equals: "web" }
      }
    ) {
      items {
        id
        token
        platform
        deviceInfo
        createdAt
      }
    }
  }
`;
